import { CircleX, Mouse, RotateCcw } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import type { MouseButtonAction, MouseButtonMap } from '../types';

export const DEFAULT_MOUSE_BUTTONS: MouseButtonMap = { left: 'current', right: 'alternate', middle: 'picker' };

interface Props {
  value: MouseButtonMap;
  saving: boolean;
  onClose: () => void;
  onSave: (value: MouseButtonMap) => void;
}

const ACTIONS: { value: MouseButtonAction; label: string }[] = [
  { value: 'current', label: '当前工具' },
  { value: 'alternate', label: '智能反向工具' },
  { value: 'pencil', label: '画笔' },
  { value: 'fill', label: '填充' },
  { value: 'eraser', label: '橡皮' },
  { value: 'picker', label: '吸色' },
  { value: 'select', label: '框选' },
  { value: 'pan', label: '移动画布' },
  { value: 'mark', label: '标记已拼' }
];

export function EditorSettingsModal({ value, saving, onClose, onSave }: Props) {
  const [draft, setDraft] = useState(value);
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => { closeRef.current?.focus(); }, []);

  const row = (key: keyof MouseButtonMap, label: string, note: string) => (
    <label className="mouse-map-row" htmlFor={`mouse-map-${key}`}>
      <span><strong>{label}</strong><small>{note}</small></span>
      <select id={`mouse-map-${key}`} value={draft[key]} onChange={(event) => setDraft((current) => ({ ...current, [key]: event.target.value as MouseButtonAction }))}>
        {ACTIONS.map((action) => <option key={action.value} value={action.value}>{action.label}</option>)}
      </select>
    </label>
  );

  return <div className="modal-backdrop editor-dialog-layer" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="editor-dialog" role="dialog" aria-modal="true" aria-labelledby="mouse-settings-title">
      <button ref={closeRef} className="editor-dialog-close" type="button" onClick={onClose} aria-label="关闭鼠标设置"><CircleX size={20} /></button>
      <div className="editor-dialog-heading"><span className="editor-dialog-icon"><Mouse size={21} /></span><div><p className="eyebrow">EDITOR INPUT</p><h2 id="mouse-settings-title">鼠标按键设置</h2><p>配置会保存到账号，并在其他设备登录后自动同步。</p></div></div>
      <div className="mouse-map-list">
        {row('left', '鼠标左键', '建议保留为当前工具')}
        {row('right', '鼠标右键', '智能反向：画笔 ↔ 橡皮，移动 ↔ 标记')}
        {row('middle', '鼠标中键', '默认按下滚轮即可吸色')}
      </div>
      <div className="editor-dialog-note">触控笔和单指触控继续使用当前工具；双指手势始终用于缩放。</div>
      <footer className="editor-dialog-actions"><button className="soft-dialog-button" type="button" onClick={() => setDraft(DEFAULT_MOUSE_BUTTONS)}><RotateCcw size={16} />恢复默认</button><button className="primary-button compact" type="button" disabled={saving} onClick={() => onSave(draft)}>{saving ? '正在同步…' : '保存并同步'}</button></footer>
    </section>
  </div>;
}
